export const featureName = 'staff';

export const staffTypeEnum = {
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  CASHIER: 'CASHIER',
};

export const staffStatusEnum = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export type StaffType = (typeof staffTypeEnum)[keyof typeof staffTypeEnum];
export type StaffStatus = (typeof staffStatusEnum)[keyof typeof staffStatusEnum];
export type Gender = 'MALE' | 'FEMALE';

export interface IStaffDetailsType {
  id: string;
  firstName: string;
  lastName: string;
  birthday: string | null;
  address: string;
  city: string;
  state: string;
  zip: string;
  email: string;
  phone: string;
  avatar: string | null;
  passCode: string;
  qrCode: string;
  staffType: StaffType;
  gender: Gender;
  status: StaffStatus;
  createdDate: string;
}
export interface IFormStaffDetails extends Omit<IStaffDetailsType, 'birthday'> {
  dob: string | null;
}

export interface GetStaffListParams {
  staffType?: string;
  keySearch?: string;
  status?: string;
}

export interface CreateOrUpdateStaffBody {
  id?: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  gender: string;
  birthday?: string;
  dob?: string; //use to update
  address: string;
  city: string;
  state: string;
  zip: string;
  avatar: string;
  passCode: string;
  staffType: string;
}
